import React from 'react';
import { FormattedMessage, FormattedDate } from 'react-intl';

import globalMessages from 'components/globalMessages';

export const getRelativeDate = (date, currentDate = new Date()) => {
  const formatedDate = date?.includes(':') ? date : `${date}T00:00:00`;
  const dateObj = new Date(formatedDate);

  if (isToday(dateObj, currentDate)) return <FormattedMessage {...globalMessages.today} />;
  if (isTomorrow(dateObj, currentDate)) return <FormattedMessage {...globalMessages.tomorrow} />;
  return <FormattedDate value={new Date(dateObj)} year="numeric" month="long" day="numeric" />;
};

export const isToday = (date: Date, currentDate: Date = new Date(), timezone?: string): boolean => {
  const compareDate = convertDateToVenueTimezone(date, timezone);

  const currentDateAdjusted = convertDateToVenueTimezone(currentDate, timezone);
  return isSameDate(compareDate, currentDateAdjusted);
};

export const isTomorrow = (date: Date, currentDate: Date = new Date(), timezone?: string): boolean => {
  const compareDate = convertDateToVenueTimezone(date, timezone);
  const tomorrow = convertDateToVenueTimezone(new Date(currentDate.getTime()), timezone);

  tomorrow.setDate(tomorrow.getDate() + 1);

  return isSameDate(compareDate, tomorrow);
};

export const isSameDate = (date1: Date, date2: Date): boolean =>
  new Date(date1).setHours(0, 0, 0, 0) === new Date(date2).setHours(0, 0, 0, 0);

export const convertDateToVenueTimezone = (date: Date, tzString: string): Date =>
  new Date(
    (typeof date === 'string' ? new Date(date) : date).toLocaleString('en-US', { timeZone: tzString })
  );

// Inverse of convertDateToVenueTimezone. Given a "shifted" Date whose device-local
// fields encode the venue wall-clock (i.e. the output of convertDateToVenueTimezone),
// recover the real UTC instant. Uses the standard two-pass offset technique so DST
// boundaries resolve correctly.
export const convertVenueTimezoneToUtc = (shiftedDate: Date, tzString: string): Date => {
  const shiftedMs = (typeof shiftedDate === 'string' ? new Date(shiftedDate) : shiftedDate).getTime();
  const tzOffsetMs = (instant: number): number =>
    convertDateToVenueTimezone(new Date(instant), tzString).getTime() - instant;
  // shiftedMs = real + tzOffsetMs(real). Recover real, second pass handles DST edges.
  const guess = shiftedMs - tzOffsetMs(shiftedMs);
  const real = shiftedMs - tzOffsetMs(guess);
  return new Date(real);
};
